export const GetGlossary= Symbol('GetGlossary');

/**
 * 术语表项
 */
export interface GlossaryItem {
    chinese_term: string;
    english_term: string;
}

/**
 * 术语表
 * @description 术语表返回内容
 */
export interface Glossary {
    id: string;
    title: string;
    term_pair: GlossaryItem[];
}

/**
 * 获取术语表
 * @description 用于获取术语表
 * @returns 术语表
 */
export interface GetGlossary {
    getGlossary(): Promise<Glossary>;
}
